import entities from "./entities/en";
import pages from "./pages/en";
import globals from "./globals/en";

export default { entities, pages, globals };
